<div class="d-flex align-items-end mb-3">
    <h1 class="fs-3 fw-light mb-1">Categoria de equipamento</h1>
    <button mat-flat-button color="primary" class="ms-auto" [appOpenInNewTab]="['equipamento', 'categoria', 'nova']">NOVA CATEGORIA</button>
</div>
<generate-table 
    [dataSource]="dataSource" [columns]="columns" [loading]="loading"
    [total]="pagination.total" [pageSize]="pagination.pageSize" 
    (pageEvent)="search($event)"
></generate-table>